import React from 'react'

const Img = (props) => {
  return (
    <img {...props} loading={props.lazy ? 'lazy' : 'eager'} src={typeof window == 'undefined' ? props.src.replace('.png', '.webp').replace('.jpeg', '.webp').replace('.jpg', '.webp') : typeof window !== 'undefined'   && !localStorage.getItem('_webpSupport') ? props.src : props.src.replace('.png', '.webp').replace('.jpeg', '.webp').replace('.jpg', '.webp')} />
  )
}

export default Img